@if (showLandscapeWarning()) {
  <div class="c-force-landscape">
    <div class="e-juliet"></div>

    <slotcom-tooltip-bubble
      id="tooltip-bubble-2"
      [classes]="['c-tooltipBubble--onboarding']"
      [borderRadius]="75"
      arrowPosition="none">
      <span
        class="text"
        [innerHTML]="'home.shared.landscape-warning.title' | translate"></span>
    </slotcom-tooltip-bubble>

    <div class="e-rotate">
      <span class="e-rotate__img"></span>

      <span
        class="text subtitle"
        [innerHTML]="'home.shared.landscape-warning.subtitle' | translate">
      </span>
    </div>
  </div>
}
